import { render, staticRenderFns } from "./KeyCap.vue?vue&type=template&id=c6067c7a&scoped=true"
import script from "./KeyCap.vue?vue&type=script&lang=js"
export * from "./KeyCap.vue?vue&type=script&lang=js"
import style0 from "./KeyCap.vue?vue&type=style&index=0&id=c6067c7a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6067c7a",
  null
  
)

export default component.exports